import React from "react";
import { Link } from "react-router-dom";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { decorators } from "@orange-marmalade/paginate-this";
import { DataTable, PartNumber, CompanyName } from "MODULES/shared/components";
import { NoteTooltipTableCell } from "MODULES/shared/components/NoteTooltip";
import { shortDate } from "LIB/formatters/date";
import translateProps from "MODULES/shared/decorators/translateProps";
import {
  CONDITION_TYPES,
  RECEIVING_TYPES,
  QC_HOLD,
  UNDER_REVIEW
} from "MODULES/Receiving/constants";
import StatusTags from "MODULES/Receiving/components/shared/StatusTags";
import LocationFlag from "MODULES/shared/components/LocationFlag/LocationFlag";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";
import BuildLink from "MODULES/inventories/components/Search/BuildLink";
import { getFirstNameLastInitial, truncate } from "LIB/formatters/text";

function BasicRow({ record, statuses, handleClick }) {
  return (
    <tr className="clickable" onClick={handleClick}>
      <td>{record.code}</td>
      <td>{shortDate(record.created_at)}</td>
      <td>{RECEIVING_TYPES[record.receiving_type].label}</td>
      <td>
        <CompanyName flattenedCompany={record} truncateAt={18} />
      </td>
      <td>{getFirstNameLastInitial(record.created_by.full_name)}</td>
      <MultiLocationFeature>
        <td>
          <LocationFlag location={record.store_location_id} />
        </td>
      </MultiLocationFeature>
      <td>
        <PartNumber part={record.part} />
      </td>
      <td>
        {record.inventories.length > 0 ? (
          <Link
            onClick={e => e.stopPropagation()}
            to={`/inventories/${record.inventories[0].uuid}`}
          >
            {record.serial_number}
          </Link>
        ) : (
          record.serial_number
        )}
      </td>
      <td>{truncate(record.part.description, 14)}</td>
      <BuildLink {...record} />
      <td>{CONDITION_TYPES[record.condition].abbrev}</td>
      <td className="text-center">{record.quantity}</td>
      <td>{record.awb_number}</td>
      <td>{record.reference_record_invoice_number}</td>
      <td>
        <StatusTags {...statuses} />
      </td>
      <NoteTooltipTableCell
        note={
          record.discrepancies[record.discrepancies.length - 1] &&
          record.discrepancies[record.discrepancies.length - 1].reason
        }
      />
      <NoteTooltipTableCell
        note={
          record.discrepancies[record.discrepancies.length - 1] &&
          record.discrepancies[record.discrepancies.length - 1]
            .reason_for_resolution
        }
      />
      <NoteTooltipTableCell note={record.minor_note} />
    </tr>
  );
}

BasicRow.propTypes = {
  record: PropTypes.shape({}),
  statuses: PropTypes.shape({}),
  handleClick: PropTypes.func
};

const statuses = record => ({
  discrepancies: record.inventories.some(i => !i.discrepancies_resolved),
  hold: record.inventories.some(i => i.qc_status === QC_HOLD),
  underReview: record.inventories.some(i => i.qc_status === UNDER_REVIEW)
});

const withProps = translateProps(({ record, pushHistory }) => ({
  statuses: { ...statuses(record) },
  handleClick: () => pushHistory(`/receiving/${record.uuid}`)
}));

const Row = connect(undefined, { pushHistory: push })(withProps(BasicRow));

export function Table({ results, isLoading }) {
  return (
    <DataTable loading={isLoading}>
      <DataTable.Head>
        <th>REC #</th>
        <th>REC Date</th>
        <th>Type</th>
        <th>Company</th>
        <th>Receiver Name</th>
        <MultiLocationFeature>
          <th>Store Loc</th>
        </MultiLocationFeature>
        <th>Part #</th>
        <th>Serial #</th>
        <th>Description</th>
        <th>REF #</th>
        <th>COND Rec</th>
        <th className="text-center">QTY Rec</th>
        <th>AWB #</th>
        <th>Inv #</th>
        <th>Status</th>
        <th>Discr</th>
        <th>Resol</th>
        <th>Note</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(record => <Row key={record.id} record={record} />)}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired
    })
  ).isRequired,
  isLoading: PropTypes.bool.isRequired
};

const Decorated = decorators.tabulate(Table);

export default () => <Decorated listId="receivingRecords" />;



// WEBPACK FOOTER //
// ./app/modules/Receiving/Search/Table.jsx